<template>
  <div class="actions actions-stacked one-action" :class="{single: single, 'two-action': status === 'Editing'}">
    <div
      class="action get-reviewed grow"
      v-if="status === 'Available' || status === 'HoldingUnproven'"
      @click="$store.commit('toggleChoosingReview', book)"
    >Get Reviewed</div>
    <div
      class="action edit grow"
      v-if="status === 'Editing' || single"
      @click="$router.push('/books/edit/' + book.id)"
    >Edit</div>
    <div class="clearfix"></div>
    <div
      class="action delete edit grow"
      v-if="status === 'Editing'"
      @click="toggleConfirmDeleteModal"
    >Delete</div>
    <info-modal
      v-if="showConfirmDeleteModal"
      title="Delete Your Draft?"
      v-on:close="toggleConfirmDeleteModal"
    >
      <div class="message">Are you sure you want to delete your draft of <span class="title-text">{{ book.title }}</span>?</div>
      <template v-slot:actions>
            <button class="action cancel" @click="toggleConfirmDeleteModal">Cancel</button>
            <button class="action delete" 
              :class="{ disabled: lockActionInProgress}" 
              @click="deleteBook()">
              Delete
            </button>
      </template>
    </info-modal>
  </div> 
</template>

<script>
import BookStatus from "../../values/BookStatus";
import InfoModal from '../Form/InfoModal.vue';
import Back from "../../modules/Back";
import Bus from "@/modules/Bus";

export default {
  name: "Actions",
  props: ["book", "single"],
  components: {InfoModal},
  data: function () {
    return {
      showConfirmDeleteModal: false,
      lockActionInProgress: false,
      status: this.book.status,
    };
  },
  created() {},
  methods: {
    toggleConfirmDeleteModal() {
      this.showConfirmDeleteModal = !this.showConfirmDeleteModal
    },
    async deleteBook() {
      this.lockActionInProgress = true
      const response = await Back.trashBook(this.book)
      if (response) {
        this.$toasted.show("Your draft has been deleted successfully.", {
          icon: "check_circle",
          position: "bottom-center",
          duration: 3000
        });
        Bus.$emit("UserChanged", this.book);
        this.lockActionInProgress = false
        this.showConfirmDeleteModal = false
      } else {
        this.lockActionInProgress = false
        this.$toasted.show(
          "Oops! Something went wrong. Please try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 3000
          }
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.actions {
  margin-left: 8px;
}
.action {
  margin-right: 8px !important;
}

.single {
  margin-left: 0;
  margin-top: 64px !important;
}

.one-action {
  margin-top: 25px;
}

.two-action {
  margin-top: -4px;
}

.grow {
  transition: all 0.1s ease-in-out;
}
.grow:hover {
  transform: scale(1.03);
}

.get-reviewed {
  background: #fdead0 !important;
  padding: 8px 16px 9px;
  color: #f57c00;
}

.message {
    font-size: 14pt ;
}

.title-text {
    color: $color-blue !important;
    font-weight: 600 !important;
    font-size: 15.5pt !important;
    padding-right: 2px !important;
}

.disabled {
  color: #dbdbdb !important;
  pointer-events: none;
}

.edit {
  background: #daedff;
  color: #2196f3;
}

.delete {
  background: #ffebee !important;
  color: #E57373 !important;
}

.cancel {
  color: #999;
  background: #f2f2f2;
}

@media (max-width: 1024px) {
  .actions {
    margin: 8px 0 16px 0;
    text-align: center;
  }

  .single {
    margin-left: 0;
    margin-top: 0px !important;
  }
}
</style>
